import React, { useState } from "react";
import { Link2, Loader2, CheckCircle2, XCircle, PlayCircle } from "lucide-react";
import api from "../../lib/api";
import { Button } from "../../components/ui/button";

export default function AdminLinkAudit() {
  const [data, setData] = useState(null);
  const [running, setRunning] = useState(false);

  const run = async () => {
    setRunning(true);
    try {
      const r = await api.get("/admin/link-audit");
      setData(r.data);
    } finally { setRunning(false); }
  };

  return (
    <div data-testid="admin-link-audit">
      <div className="flex items-center justify-between gap-4 mb-2 flex-wrap">
        <h1 className="font-display text-4xl font-semibold text-primary">Link audit</h1>
        <Button onClick={run} disabled={running} data-testid="link-audit-run" className="rounded-full">
          {running ? <Loader2 size={16} className="animate-spin mr-2" /> : <PlayCircle size={16} className="mr-2" />} Run audit
        </Button>
      </div>
      <p className="text-muted-foreground mb-8 flex items-center gap-2"><Link2 size={16} /> Checks internal routes and every external URL used in your content resolves correctly.</p>

      {!data ? (
        <p className="text-muted-foreground">Run the audit to see results.</p>
      ) : (
        <>
          <div className="flex gap-4 mb-6">
            <div className="rounded-2xl bg-card border border-primary/10 px-6 py-4"><p className="font-display text-3xl font-semibold text-primary" data-testid="audit-checked">{data.checked}</p><p className="text-sm text-muted-foreground">Links checked</p></div>
            <div className="rounded-2xl bg-card border border-primary/10 px-6 py-4"><p className={`font-display text-3xl font-semibold ${data.broken ? "text-red-600" : "text-emerald-600"}`} data-testid="audit-broken">{data.broken}</p><p className="text-sm text-muted-foreground">Issues found</p></div>
          </div>
          <div className="bg-card border border-primary/10 rounded-3xl divide-y divide-primary/5">
            {data.results.map((r, i) => (
              <div key={i} className="flex items-center gap-3 px-5 py-3 text-sm">
                {r.status === "ok" ? <CheckCircle2 size={17} className="text-emerald-600 shrink-0" /> : <XCircle size={17} className="text-red-500 shrink-0" />}
                <span className="flex-1 truncate text-foreground/85">{r.url}</span>
                <span className="text-xs uppercase tracking-wide text-muted-foreground">{r.type}</span>
                <span className={`text-xs font-semibold w-24 text-right ${r.status === "ok" ? "text-emerald-600" : "text-red-500"}`}>{r.status}{r.code ? ` · ${r.code}` : ""}</span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
